import React from "react";
import { seatFitBands } from "../services/seatFit.js";
import { ViewKey } from "../v2/components/ViewKey.jsx";
import { HowWeDefineThis } from "./SpacePolicyDefinitions.jsx";
import { useSpacePolicy } from "../services/spacePolicyStore.js";
export function SeatFitKey() {
  const { baseline } = useSpacePolicy();
  return <div data-testid="shared-seat-fit-key">
    {seatFitBands(baseline).map(b => <div key={b.status}>
      <strong style={{ color: b.style.ink }}>{b.label}</strong> — {b.description}
    </div>)}
    {!baseline && <p>Space Policy unavailable; bands cannot be scored.</p>}
    {baseline && <p>SF per seat below {baseline.sfFloor} shows amber, independent of the Space Fit band.</p>}
    <HowWeDefineThis />
  </div>;
}
export function SeatFitViewKey() {
  const { baseline } = useSpacePolicy();
  return <ViewKey testId="markets-seat-fit-key" title="Space fit"
    groups={[{ label: "Status", items: seatFitBands(baseline).map(b => ({
      label: b.label, description: b.description,
      labelStyle: { color: b.style.ink, background: b.style.bg },
      swatch: { kind: "cell", color: b.style.bg, border: b.style.border },
    })) }]}
    footer={<><p>Space Fit = assigned today vs installed seats. SF per seat below {baseline?.sfFloor ?? "unknown"} shows amber, independent of the band.</p><HowWeDefineThis /></>} />;
}
